'use client'

import React from 'react'
import { Loader2 } from 'lucide-react'
import { SERIES_COLORS } from './SourceLinesTopRow'
import { TakedownClockCard, type TakedownEntry } from './TakedownClockCard'

// CTT Pilot Overview: time to takedown per source — a header line with the
// source's counts, then one TakedownClockCard per clock (from detection, from
// domain registration). Purely presentational — the caller owns the period
// and each source's rows.

export type TakedownSource = {
  key: string
  label: string
  /** Index into the categorical palette, the same slot as the source's line. */
  slot: number
  entries: TakedownEntry[]
  loading?: boolean
  error?: string | null
}

export function TakedownBySourceCard({ sources, isDark }: { sources: TakedownSource[]; isDark: boolean }) {
  const muted = 'text-subtle'
  const label = 'text-muted-foreground'

  return (
    <>
      {sources.map((s) => {
        const withDomain = s.entries.filter((e) => e.has_domain).length
        const dead = s.entries.filter((e) => e.dead).length
        return (
          <div key={s.key} className="col-span-full flex flex-col gap-1">
            <div className="flex items-center gap-1.5 px-1 pt-1">
              <span className="h-2 w-2 shrink-0 rounded-full" style={{ background: SERIES_COLORS[s.slot % SERIES_COLORS.length][isDark ? 'dark' : 'light'] }} />
              <span className={`font-mono text-[10px] uppercase tracking-widest ${label}`}>{s.label} · time to takedown</span>
              {s.loading && <Loader2 className={`h-3 w-3 animate-spin ${muted}`} />}
              <span className={`font-mono text-[10px] ${s.error ? 'text-destructive' : muted}`}>
                {s.error ?? (s.loading ? '' : `${s.entries.length} entries · ${withDomain} with domain · ${dead} dead`)}
              </span>
            </div>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
              <div className="h-60"><TakedownClockCard entries={s.entries} clock="detected_at" isDark={isDark} /></div>
              <div className="h-60"><TakedownClockCard entries={s.entries} clock="registered_at" isDark={isDark} /></div>
            </div>
          </div>
        )
      })}
    </>
  )
}
